import React from 'react'
import ReactTable from "react-table";
import "react-table/react-table.css";
import { AsyncPaginate } from 'react-select-async-paginate';
import Loading from "../../components/LoadingTable";
import TextField from '@mui/material/TextField';


const TableSubmit = (props) => {

    // Get JSX code for error reporting
    const getJSXerror = (row) => (
        row.error !== "" ?
            <i id={"error_form_"+row.id+"-"+row.index}>
                <font color="red"> {row.error} </font>
            </i>
        :null
    );

    // Get JSX code for Select options
    const getJSXSelectOptions = (header,row) => (
        header.selection.map(optionItem => {
            return (optionItem === row.value) ?
                       <option value={optionItem} selected >
                           {optionItem}
                       </option>
                   :
                       <option value={optionItem}>
                           {optionItem}
                       </option>
        })
    );
    
    // Get JSX code for Multiple select options 
    const getJSXMultipleOptions = (header) => (
        header.selection.map(optionItem => {
            return <option value={optionItem}> {optionItem} </option>
        })
    );
    
    // Get Headers according to View Fields Configurations
    const getHeaders = (headers,embargoHandler,copyReason) =>
    {
        // 1. LogoutButton Format:
        //     [ { id:"ID", title : "myTitle", inputType:"text | select | selectMultiple | number" , description:"", mandatory:true, selection:[...]} ]
        let columns = [];
        for (let header of headers){
            // 1.0 Generate LogoutButton
            let headerTable = {"accessor":header.id};
            // 1.1 Title Content
            let checkboxItem = "";
            if(header.id === "embargoPeriodReason"){
                checkboxItem = <input type="checkbox" checked={copyReason} onChange={embargoHandler} />;
            }
            // 1.2 Tooltip LogoutButton
            if ("mandatory" in header || "description" in header){
                headerTable["Header"] =  props => <div> {checkboxItem} 
                                                        {header.title} 
                                                        {
                                                            header.mandatory ? <font color="red"> * </font> : null
                                                        }
                                                        { 
                                                            header.description !== "" ?
                                                                <label title={header.description}> 
                                                                    <i className="fa fa-comment-o" aria-hidden="true"></i>
                                                                </label>
                                                            : null 
                                                        } 
                                                  </div>;
            }
            else{
                headerTable["Header"] = header.title;
            }
            headerTable["style"] = { 'white-space': 'unset' }
            headerTable["width"] = header.width;
            columns.push(headerTable);
        }
        return columns;
    };
        

    // onChange is the changeHandler in Submission
    const getInputCellContents = (fieldHeader,fieldObject,onChange) =>
    {
        // 1.Return JSX Object according to the input type
        switch (fieldHeader.inputType) {
            case "text":
                return (<div> 
                            <input type="text" name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.value} 
                                   onChange={onChange} style={{minWidth: "240px"}}/>
                            {getJSXerror(fieldObject)} 
                        </div>);
            case "textReadOnly":
                return (<div> 
                            <TextField disabled id="standard-basic" onChange={onChange} variant="standard"
                                       name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.value} />
                            {getJSXerror(fieldObject)} 
                        </div>);
            case "select-experiment":
                return (<div>
                            <AsyncPaginate name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.valueIndex}
                                           loadOptions={props.loadExperiments} 
                                           onChange={props.changeSelectExperiment}  
                                           additional={{page: 1}}
                                           menuPortalTarget={document.body} />
                            {getJSXerror(fieldObject)}
                        </div>);
            case "select-participant":
                return (<div>
                            <AsyncPaginate name={fieldObject.id+"-"+fieldObject.index} 
                                           value={fieldObject.valueIndex}
                                           loadOptions={props.loadParticipants} 
                                           onChange={props.changeSelectAutocomplete}  
                                           additional={{page: 1}}
                                           menuPortalTarget={document.body} />
                            {getJSXerror(fieldObject)}
                        </div>);
            case "select":
                return (<div> 
                            <select name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.value} onChange={onChange}>
                                {getJSXSelectOptions(fieldHeader,fieldObject)} 
                            </select> 
                            {getJSXerror(fieldObject)} 
                        </div>);
            case "selectMultiple":
                return (<div>
                            <select multiple={true} name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.value} onChange={onChange}>
                               {getJSXMultipleOptions(fieldHeader)} 
                            </select> 
                            {getJSXerror(fieldObject)} 
                        </div>);
            case "number":
                return (<div> 
                           <input type="number" name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.value} onChange={onChange}/>
                           {getJSXerror(fieldObject)} 
                        </div>);
            case "file":
                return (<div> 
                           <input type="file" name={fieldObject.id+"-"+fieldObject.index} value={fieldObject.value} onChange={onChange} />
                           {getJSXerror(fieldObject)} 
                        </div>);
            case "fileMultiple":
                return (<div> 
                           <input type="file" name={fieldObject.id+"-"+fieldObject.index}  onChange={onChange} multiple/>
                           {getJSXerror(fieldObject)} 
                        </div>);
        }
    };
    
   
    // Get Data for React Table
    const getData = (headers,data,onChange) =>
    {
        // 1.Headers [ { id:"ID", title : "myTitle", inputType:"text | select | selectMultiple | number" , description:"", mandatory:true, selection:[...]} ]
        // 2.Data  [{id:"ID", value:'VALUE'},...,{id:"ID", value:'VALUE'}] ,..., [{id:"ID", value:'VALUE'},...,{id:"ID", value:'VALUE'}]
        let dataTable = [];
        for (let row of data){
            let dataRow = {};
            for (let field of row){
                // 1.1 Search for the Colum LogoutButton for a given field
                let fieldHeader = headers.find(header => header.id === field.id);
                // 1.2 Add data row
                dataRow[field.id] = getInputCellContents(fieldHeader,field,onChange);
            }
            // 2.0 Push Data Row
            dataTable.push(dataRow);
        }
        return dataTable;
    }; 
 
    // Parse raw data for columns and rows from props
    const columns = getHeaders(props.headers,props.embargoHandler,props.copyReason);
    const data = getData(props.headers,props.contents,props.changeHandler);
    
    return (
        <ReactTable  data={data} columns={columns}
                     minRows={0}
                     pageSizeOptions={[50,100, 200, 500]} 
                     defaultPageSize={100}
                     sortable={false}
                     loading={props.loading}
                     LoadingComponent={Loading}
                     className="-striped -highlight"
                     style={{
                             height: 600
                     }} />
    );
}


const customStyles = {
    container: (base, state) => {
        return ({
                    ...base,
                    zIndex: state.isFocused ? "999" : "1"  //Only when current state focused
                })
    }
}


export default TableSubmit;
